import { render, staticRenderFns } from "./PLUnitOv.vue?vue&type=template&id=3dedd59c"
import script from "./PLUnitOv.vue?vue&type=script&lang=js"
export * from "./PLUnitOv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports